import { ReactElement } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface DisabledReasonWrapperProps {
  reason?: string;
  children: ReactElement;
  className?: string;
}

// Wraps a disabled element in a tooltip explaining why it's disabled; renders the
// child unchanged when there's no reason.
export const DisabledReasonWrapper = ({
  reason,
  children,
  className
}: DisabledReasonWrapperProps) => {
  if (!reason) {
    return children;
  }
  return (
    <OverlayTrigger placement='top' overlay={<Tooltip className={className}>{reason}</Tooltip>}>
      {children}
    </OverlayTrigger>
  );
};
